import { tns } from 'tiny-slider';
import 'tiny-slider/dist/tiny-slider.css';

export default function initSliders() {
    const sliderElements = document.querySelectorAll('.slider');

    sliderElements.forEach(sliderElement=>{
        tns({
            gutter: 5,
            items: 1,
            nextButton: sliderElement.querySelector('.next'),
            prevButton: sliderElement.querySelector('.prev'),
            center: true,
            nav: false,
            container: sliderElement.querySelector('.tns-slides'),
            speed: 400,
            mouseDrag: true,
            swipeAngle: 60,
        });
    })
}

initSliders();